// extracted by mini-css-extract-plugin
module.exports = {"dividerHorizontal":"styles_dividerHorizontal__1kBlr","dividerVertical":"styles_dividerVertical__2oA8-"};